/** Workspace widget zones */
export enum WidgetZoneType {
  salesandrange = 'salesandrange',
  planyourday = 'planyourday',
  communicationandcollab = 'communicationandcollab',
  tools = 'tools',

  /** Zones created by user. Will have a display name. */
  custom = 'custom',

  /** Pushed widget zone. Shown last and only if it contains any widgets. */
  pushed = 'pushed'
}

/** List with all widget zones */
export const ALL_WIDGET_ZONE_TYPES: WidgetZoneType[] = Object.keys(WidgetZoneType).map(key => WidgetZoneType[key]);
